<template><!-- svgo-optimised -->
<svg class="icon icon__menu" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg"><path d="M0 1h18M0 7h18M0 13h18" stroke="currentColor"/></svg></template>